import logo from './logo.png'

export const theme = {
    color: {
      primary: "#009ee3",
      primaryHover: "#0286e3",
    },
    logoImage: logo,
    backend: "https://epaperjournal.swissmechanic.ch/",
    directory: "/kiosk",
    header: {
      customer: "",
      title: "Swissmechanic Journal",
    },
    info: [
      {
      text: 'Impressum',
      link: 'https://www.swissmechanic.ch/service/impressum'
    },
      {
      text: 'Datenschutz',
      link: 'https://www.swissmechanic.ch/datenschutz'
    },
  ],
  login: {
    type: "internal",
  }
  };